import EzController from 'controllers/ez-base-controller';
import { ezErrorDisplay, ezErrorDisplayOff } from 'ez-styles/assets/javascripts/ez-styles/utils/errors';
import { parseErrorMsg } from 'lib/validation-helpers';
import $script from 'scriptjs';

export default class FacebookButtonController extends EzController {
  static targets = ['button', 'text'];

  connect() {
    this.error = false;
    this.originalText = this.textTarget.innerHTML;
    this.auth_type = 'reauthorize';

    this.initFB();
  }

  set loading(value) {
    if (value) {
      this.textTarget.innerHTML = this.element.dataset.loadingText;
    } else {
      this.textTarget.innerHTML = this.originalText;
    }
  }

  set error(value) {
    if (value) {
      ezErrorDisplay(this.buttonTarget, parseErrorMsg(this.element, 'permissions_error'));

      this.auth_type = 'rerequest';
    } else {
      ezErrorDisplayOff(this.buttonTarget);
    }
  }

  initFB() {
    $script('https://connect.facebook.net/en_US/sdk.js', () => {
      window.FB.init({
        appId: this.element.dataset.facebookAppId,
        autoLogAppEvents: true,
        cookie: true,
        status: true,
        xfbml: false,
        version: 'v3.2',
      });
    });
  }

  connectFacebook() {
    this.loading = true;

    this.login().then(
      () => {
        this.validate().then(
          () => this.redirect(),
          () => {
            this.loading = false;
            this.error = true;
          },
        );
      },
      () => {
        this.error = false;
        this.loading = false;
      },
    );
  }

  login() {
    return new Promise((resolve, reject) => {
      window.FB.login(
        (response) => {
          if (response.status === 'connected') {
            resolve();
          } else {
            reject();
          }
        },
        { scope: 'public_profile,email', auth_type: this.auth_type },
      );
    });
  }

  validate() {
    return new Promise((resolve, reject) => {
      window.FB.api('/me/permissions', (response) => {
        response.data.forEach((permission) => {
          if (
            permission.permission === 'email'
            && permission.status !== 'granted'
          ) {
            reject();
          }

          if (
            permission.permission === 'public_profile'
            && permission.status !== 'granted'
          ) {
            reject();
          }
        });

        resolve();
      });
    });
  }

  redirect() {
    const f = document.createElement('form');
    f.style.display = 'none';
    this.element.appendChild(f);
    const csrfField = document.createElement('input');
    csrfField.value = this.csrfToken;
    csrfField.name = 'authenticity_token';

    f.appendChild(csrfField);
    f.method = 'POST';
    f.action = this.element.dataset.omniauthPath;
    f.submit();
  }
}
